import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    margin: "5% auto 0  auto",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  control: {
    height: "200px",
  },
}));

export default function AboutUs() {
  const classes = useStyles();

  return (
    <div
      className={classes.container}
      justify="center"
      style={{ maxWidth: "1100px", marginBottom: "8px" }}
    >
      <div className={classes.root}>
        <Typography
          variant="h4"
          style={{
            textAlign: "center",
            margin: "0 auto 30px auto",
            paddingTop: "5%",
            color: "white",
          }}
          id="out-team"
        >
          Our Team
        </Typography>
        <Grid
          item
          justify="center"
          container
          className={classes.root}
          spacing={2}
          style={{ paddingBottom: "2%" }}
        >
          <Grid item xs={11} sm={6} style={{ textAlign: "center" }}>
            <div style={{ borderRadius: "50%" }}>
              <img
                src="image/ishaan.jpg"
                style={{
                  borderRadius: "50%",
                  margin: "10px auto auto 10px",
                }}
                alt="Ishaan Gupta"
                width="200px"
                height="200px"
              />
              <Typography variant="h5" style={{ color: "white" }}>
                Ishaan Gupta
                <Typography>Founder</Typography>
                <Typography>Android Developer</Typography>
              </Typography>
            </div>
          </Grid>
        </Grid>
        <Grid
          item
          justify="center"
          container
          className={classes.root}
          spacing={2}
          style={{ paddingBottom: "5%" }}
        >
          <Grid item xs={11} sm={4} style={{ textAlign: "center" }}>
            <div style={{ borderRadius: "50%" }}>
              <img
                src="image/devashish.jpg"
                style={{
                  borderRadius: "50%",
                  margin: "10px auto auto 10px",
                }}
                alt="Devashish Bhandari"
                width="150px"
                height="150px"
              />
              <Typography variant="h5" style={{ color: "white" }}>
                Devashish Bhandari
                <Typography></Typography>
                <Typography>Graphic Designer</Typography>
              </Typography>
            </div>
          </Grid>
          <Grid item xs={11} sm={4} style={{ textAlign: "center" }}>
            <div style={{ borderRadius: "50%" }}>
              <img
                src="image/aditya.jpg"
                style={{
                  borderRadius: "50%",
                  margin: "10px auto auto 10px",
                }}
                alt="Aditya Gusain"
                width="160px"
                height="160px"
              />
              <Typography variant="h5" style={{ color: "white" }}>
                Aditya Gusain
                <Typography></Typography>
                <Typography>Web Developer</Typography>
              </Typography>
            </div>
          </Grid>
          <Grid item xs={11} sm={4} style={{ textAlign: "center" }}>
            <div style={{ borderRadius: "50%" }}>
              <img
                src="image/daksh1.jpeg"
                style={{
                  borderRadius: "50%",
                  margin: "10px auto auto 10px",
                }}
                alt="Daksh Malhotra"
                width="150px"
                height="150px"
              />
              <Typography variant="h5" style={{ color: "white" }}>
                Daksh Malhotra
                <Typography></Typography>
                <Typography>Web Developer</Typography>
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
